import {
  Checkbox,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useBaseContext } from "../../context/BaseContext";
import { ClassNameType, CLASS_NAMES } from "./ClassData";

export const ClassSelector = () => {
  const { selectedClass, setSelectedClass } = useBaseContext();
  const [open, setOpen] = useState(false);

  const handleChange = (event: SelectChangeEvent<ClassNameType[]>) => {
    const {
      target: { value },
    } = event;
    setSelectedClass(
      typeof value === "string" ? (value.split(",") as ClassNameType[]) : value
    );
  };

  return (
    <>
      <Typography
        variant="h2"
        sx={{
          cursor: "pointer",
          fontWeight: "bold",
          alignSelf: "end",
          background: "rgba(255,255,255,1)",
          color: "#333",
          borderRadius: 5,
          padding: 2,
        }}
        onClick={() => setOpen(true)}
      >
        {selectedClass.join(", ") || "Select class"}
      </Typography>

      <Select
        sx={{
          position: "absolute",
          opacity: 0,
          width: 0,
          height: 0,
          overflow: "hidden",
        }}
        multiple
        open={open}
        onClose={() => setOpen(false)}
        value={selectedClass}
        onChange={handleChange}
      >
        {CLASS_NAMES.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selectedClass.includes(name)} /> {name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
